<template>
  <div>
    <copy-hedge-type
      :window-visible="windowVisible"
      @close="closeModal"
      @save="closeAndRefresh"
    ></copy-hedge-type>

    <kendo-grid
      height="calc(100vh - 125px)"
      ref="hedgeTypeGrid"
      :editable="!isReadOnly && 'inline'"
      :toolbar="
        !this.isReadOnly
          ? ['create', {name: 'toggleWindow', iconClass: 'k-icon k-i-copy', text: 'Copy'}]
          : []
      "
      :dataSource="dataSource"
      :columns="columns"
      :pageable="true"
    ></kendo-grid>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import {jsonDropDownEditor} from '@/helpers/kendo-editors'
import {enableExportExcel} from '@/helpers/export-helper'
import CopyHedgeType from './CopyHedgeType'
import notification from '@/helpers/notification'
import security from '@/mixins/security'

export default {
  name: 'HedgeTypeView',
  mixins: [security],
  components: {
    CopyHedgeType,
  },
  mounted() {
    let grid = this.$refs.hedgeTypeGrid.kendoWidget()
    enableExportExcel(grid, '/api/config/hedgeType/exportToExcel')
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    columns() {
      return [
        {
          hidden: this.isReadOnly,
          command: 'edit',
          title: '&nbsp;',
          width: 55,
        },
        {
          title: 'Code',
          field: 'code',
          width: 82,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
        },
        {
          title: 'Name',
          field: 'name',
          width: 282,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
        },
        {
          title: 'Hedge Type Category',
          field: 'hedgeTypeCategoryName',
          width: 232,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
          editor: jsonDropDownEditor(
            'hedgeTypeCategoryId',
            'hedgeTypeCategoryName',
            '/api/config/hedgeType/getHedgeTypeCategory',
            {},
            false,
          ),
        },
        {
          command: [{name: 'destroy', visible: dataItem => dataItem.canBeDeleted}],
          width: 82,
          attributes: {style: 'text-align: center;'},
          hidden: this.isReadOnly,
        },
        {
          command: [
            {
              name: 'toggleWindow',
              icon: 'copy',
              text: 'Copy',
              click: this.toggleModal,
            },
          ],
          title: '&nbsp;',
          hidden: true,
        },
        {},
      ].filter(c => c.editable !== false)
    },
  },
  methods: {
    toggleModal() {
      let grid = this.$refs.hedgeTypeGrid.kendoWidget()
      var totalRecords = grid.dataSource.total()
      if (totalRecords === 0) {
        this.windowVisible = !this.windowVisible
      } else {
        notification('Delete all hedge types before copying from another client.', 'error')
      }
    },
    openModal() {
      this.windowVisible = true
    },
    closeModal() {
      this.windowVisible = false
    },
    closeAndRefresh() {
      let grid = this.$refs.hedgeTypeGrid.kendoWidget()
      grid.dataSource.read()
      this.closeModal()
    },
  },
  data() {
    return {
      windowVisible: false,
      dataSource: {
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 10,
        transport: {
          read: {
            type: 'GET',
            url: '/api/config/hedgeType',
            data: () => ({clientId: this.clientId}),
            dataType: 'json',
          },
          create: {
            type: 'POST',
            url: '/api/config/hedgeType',
            data: () => ({clientId: this.clientId}),
            dataType: 'json',
          },
          update: {
            type: 'PUT',
            url: '/api/config/hedgeType',
            data: () => ({clientId: this.clientId}),
            dataType: 'json',
          },
          destroy: {
            type: 'DELETE',
            url: '/api/config/hedgeType',
            data: () => ({clientId: this.clientId}),
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'hedgeTypeId',
            fields: {
              hedgeTypeId: {type: 'number', editable: false},
              code: {type: 'string', validation: {required: true}},
              name: {type: 'string', validation: {required: true}},
              hedgeTypeCategoryId: {type: 'number', validation: {required: true}, defaultValue: 0},
              hedgeTypeCategoryName: {
                type: 'string',
                validation: {required: true},
                defaultValue: 'Not Available',
              },
              canBeDeleted: {type: 'bool', defaultValue: true, editable: false},
            },
          },
        },
      },
    }
  },
}
</script>
